/**
 * `/merchandising/orders` — Garment Orders, the commercial intake list (ADR-0039).
 * First item in the Merchandising section: buyers commit here; Style Files are
 * linked later. Gated by the `garment.styles` entitlement server-side.
 *
 * @see prototype/garment/order-book.html — the list grammar this mirrors
 * @see docs/adr/0039-garment-order-intake.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GarmentOrdersListPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/orders/")({
  component: OrdersRoute,
});

function OrdersRoute() {
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Merchandising", to: "/" }, { label: "Orders" }]}>
      <GarmentOrdersListPage />
    </WorkspaceShell>
  );
}
